import React, { Component } from 'react';
import Radium from 'radium';

import BubbleTick from './BubbleTick';

class TaskCircle extends Component {
	render() {
		var tick = null;
		var containerStyles = [this.localStyles().container];

		if (this.props.completed) {
			tick = (
				<BubbleTick
					id={this.props.selectedBubble ? this.props.selectedBubble.id : "default"}
					color1={this.getColor1()}
					color2={this.getColor2()}
				/>
			);
		}

		if (this.props.placeholder) {
			containerStyles.push(this.localStyles().containerPlaceholder);
		}
		
		return (
			<div style={containerStyles} onClick={(evt) => this.props.onTick(evt)}>
				<div style={this.localStyles().innerCircle}>
					{tick}
				</div>
			</div>
		);
	}

	getColor1() {
		if (this.props.selectedBubble) {
			return this.props.selectedBubble.color_1
		}

		return this.props.style.colors.defaultGradient.color1;
	}

	getColor2() {
		if (this.props.selectedBubble) {
			return this.props.selectedBubble.color_2
		}

		return this.props.style.colors.defaultGradient.color2;
	}

	localStyles()  {
		return {
			container: {
				backgroundImage: `linear-gradient(0deg, ${this.getColor1()} 0%, ${this.getColor2()} 100%)`,
				width: 30,
				minWidth: 30,
				height: 30,
				borderRadius: 15,
				marginRight: 20,
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "center",
				userSelect: "none"
			},
			containerPlaceholder: {
				backgroundImage: "none",
				backgroundColor: this.props.style.colors.lightText
			},
			innerCircle: {
				width: 22,
				height: 22,
				backgroundColor: this.props.style.colors.white,
				borderRadius: 11,
				display: "flex",
				alignItems: "center",
				justifyContent: "center"
			},
			tickImage: {
				width: 14,
				height: 12
			}
		}
	};

}

export default Radium(TaskCircle);


// WEBPACK FOOTER //
// ./src/components/TaskCircle.js